<template>
  <teleport :to="getContainer()">
    <div
      ref="modalWrapRef"
      class="draggable-modal"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <div class="modal-wrap">
        <div class="modal" :class="{ expanded: hover }">
          <div class="modal-body">
            <div class="userInfo">
              <div class="left">
                <auth-img :src="TcccUserInfo.header || fallImg" />
                <div class="left-name">
                  <div class="name">{{ TcccUserInfo.userType }} - {{ TcccUserInfo.name }}</div>
                  <div class="state" v-if="!hover">
                    {{
                      handing.includes(TcccStatus)
                        ? `通话中...${displayTime}`
                        : TcccStatus === 'RingOn'
                        ? '对方已振铃...'
                        : '正在接通中...'
                    }}
                  </div>
                </div>
              </div>
              <div class="right status" v-if="hover">
                {{
                  handing.includes(TcccStatus)
                    ? `通话中...${displayTime}`
                    : TcccStatus === 'RingOn'
                    ? '对方已振铃...'
                    : '正在接通中...'
                }}
              </div>
            </div>
            <div class="history" v-if="hover && data.intentTitle && data.lastServeText">
              <div class="service-inquiry" v-if="data.intentTitle">{{ data.intentTitle }}</div>
              <div class="last-service" v-if="data.lastServeText">
                上次服务：{{ data.lastServeText }}
              </div>
            </div>
            <a-space :size="8" class="action" v-if="hover">
              <div @click="close" class="btn close">挂断</div>
              <!-- <div @click="getWorkOrder" v-if="TcccStatus == 'Pending'" class="btn">查看工单</div> -->
              <!-- 转接 -->
              <template v-if="data.showTransfer">
                <!-- <div v-if="data.intentType === '1'" @click="transferToComplaint('2')" class="btn">
                  转投诉线
                </div>
                <div
                  v-else-if="data.intentType === '2'"
                  @click="transferToComplaint('1')"
                  class="btn"
                >
                  转咨询线
                </div> -->
                <div v-if="TcccUserInfo.action === 2" @click="handleTransfer" class="btn">
                  转接电话
                </div>
              </template>
              <template v-if="handing.includes(TcccStatus)">
                <div
                  v-if="['未知用户', '', null, undefined].includes(TcccUserInfo.userType)"
                  class="btn-group"
                >
                  <div @click="handleCopyPhone" class="btn">复制手机号</div>
                  <div @click="handlePreArchive" class="btn">去预建档</div>
                </div>
                <div v-else-if="TcccUserInfo.userType" @click="handleViewArchive" class="btn">
                  患者档案
                </div>
              </template>
            </a-space>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <transferPop ref="transferPopRef" />
</template>
<script setup>
import fallImg from '@/assets/img/chat/head_p.png'
import { defineProps, onMounted, nextTick, ref, onUnmounted } from 'vue'
import { throttle } from 'lodash-es'
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
import { callTransfer, hungUp } from '@/utils/Tccc'
import { useRouter } from 'vue-router'
const router = useRouter()
import { buildCallIntent, getTcccWorkOrderList } from '@/api/login'
import { prePatientSave } from '@/api/patientFile'
import { copyText } from '@/views/WorkPlace/Container/chat/components/contenteditable/clipboard'
import { useServiceInfo } from './useTransferInfo'
import transferPop from './transferPop.vue'

const store = useStore()
const TcccUserInfo = computed(() => store.state.tccc.tcccUserInfo || {})
const TcccStatus = computed(() => store.state.tccc.tcccStatus)
const handing = ['Accept', 'Pending']
const hover = ref(false)
const seconds = ref(0)
const displayTime = ref('00:00')
let timerInterval = null

const formatTime = sec => {
  const minutes = Math.floor(sec / 60)
  const remainingSeconds = sec % 60
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`
}
// 查看患者档案
const handleViewArchive = () => {
  let phone = TcccUserInfo?.value?.phone || ''
  // 电话号码去掉国际区号前缀（支持 0086、+86、86 等格式）
  phone = phone.replace(/^(?:\+|00)?86/, '')
  const params = {
    param: { phone }
  }
  store.dispatch('patientFile/handleViewArchive', params)
}
// 去预建档：未知用户先建预存档案，再打开建档/档案弹窗
const handlePreArchive = async () => {
  const info = TcccUserInfo.value || {}
  const telephone = (info.phone || '').replace(/^(?:\+|00)?86/, '')
  let patientId = info.userId
  // 未知用户（无 userId）先调保存接口建预存档案，拿到 id 再开弹窗
  if (!patientId) {
    try {
      const result = await prePatientSave({ name: '未知用户', phone: telephone })
      patientId = result?.id
    } catch (e) {
      return message.warning('建档失败，请稍后重试')
    }
  }
  if (!patientId) return message.warning('缺少患者信息，无法建档')
  store.dispatch('patientFile/openModal', {
    patientId,
    patientType: info.callerType === 1 ? 1 : 0
  })
}
// 复制手机号到剪贴板
const handleCopyPhone = async () => {
  const phone = TcccUserInfo.value?.calleePhoneNumberText || ''
  if (!phone) return message.warning('缺少手机号')
  try {
    await copyText(phone)
    message.success('手机号已复制')
  } catch (e) {
    message.warning('复制失败，请手动复制')
  }
}
// 转接操作
const transferPopRef = ref(null)
const handleTransfer = () => {
  const modalWrapRefEl = modalWrapRef.value
  const modalEl = modalWrapRefEl.querySelector('.modal')
  const rect = modalEl.getBoundingClientRect()
  const viewportWidth = document.documentElement.clientWidth // 不包含滚动条宽度
  // 计算距离右侧的距离
  const distanceToRight = viewportWidth - rect.right
  if (distanceToRight < 638) {
    modalEl.style.left = 'initial'
    modalEl.style.right = '638px'
  }
  transferPopRef.value.initModal()
}
watch(
  () => TcccStatus.value,
  val => {
    if (handing.includes(val)) {
      timerInterval = setInterval(() => {
        seconds.value++
        displayTime.value = formatTime(seconds.value)
      }, 1000)
    }
  },
  { immediate: true }
)

onUnmounted(() => {
  clearInterval(timerInterval)
})

defineProps({
  getContainer: {
    type: Function,
    default: () => document.body
  }
})
const cursorStyle = {
  top: 'n-resize',
  left: 'w-resize',
  right: 'e-resize',
  bottom: 's-resize',
  topLeft: 'nw-resize',
  topright: 'ne-resize',
  bottomLeft: 'sw-resize',
  bottomRight: 'se-resize',
  auto: 'auto'
}
let inited = false
const modalWrapRef = ref()
const registerDragTitle = (dragEl, handleEl) => {
  handleEl.style.cursor = 'move'
  handleEl.onmousedown = throttle(e => {
    document.body.style.userSelect = 'none'
    const disX = e.clientX - dragEl.getBoundingClientRect().left
    const disY = e.clientY - dragEl.getBoundingClientRect().top
    const mousemove = event => {
      let iL = event.clientX - disX
      let iT = event.clientY - disY
      const maxL = document.documentElement.clientWidth - dragEl.offsetWidth
      const maxT = document.documentElement.clientHeight - dragEl.offsetHeight
      iL <= 0 && (iL = 0)
      iT <= 0 && (iT = 0)
      iL >= maxL && (iL = maxL)
      iT >= maxT && (iT = maxT)
      dragEl.style.left = `${iL}px`
      dragEl.style.top = `${iT}px`
    }
    const mouseup = () => {
      document.removeEventListener('mousemove', mousemove)
      document.removeEventListener('mouseup', mouseup)
      document.body.style.userSelect = 'auto'
    }
    document.addEventListener('mousemove', mousemove)
    document.addEventListener('mouseup', mouseup)
  }, 20)
}
const initDrag = async () => {
  await nextTick()
  const modalWrapRefEl = modalWrapRef.value
  const modalWrapEl = modalWrapRefEl.querySelector('.modal-wrap')
  const modalEl = modalWrapRefEl.querySelector('.modal')
  if (modalWrapEl && modalEl) {
    const bodyEl = modalEl.querySelector('.modal-body')
    bodyEl && registerDragTitle(modalEl, bodyEl)
    modalWrapEl.onmousemove = throttle(event => {
      const left = event.clientX - modalEl.offsetLeft
      const top = event.clientY - modalEl.offsetTop
      const right = event.clientX - modalEl.offsetWidth - modalEl.offsetLeft
      const bottom = event.clientY - modalEl.offsetHeight - modalEl.offsetTop
      const isLeft = left <= 0 && left > -8
      const isTop = top < 5 && top > -8
      const isRight = right >= 0 && right < 8
      const isBottom = bottom > -5 && bottom < 8
      // 向左
      if (isLeft && top > 5 && bottom < -5) {
        modalWrapEl.style.cursor = cursorStyle.left
        // 向上
      } else if (isTop && left > 5 && right < -5) {
        modalWrapEl.style.cursor = cursorStyle.top
        // 向右
      } else if (isRight && top > 5 && bottom < -5) {
        modalWrapEl.style.cursor = cursorStyle.right
        // 向下
      } else if (isBottom && left > 5 && right < -5) {
        modalWrapEl.style.cursor = cursorStyle.bottom
        // 左上角
      } else if (left > -8 && left <= 5 && top <= 5 && top > -8) {
        modalWrapEl.style.cursor = cursorStyle.topLeft
        // 左下角
      } else if (left > -8 && left <= 5 && bottom <= 5 && bottom > -8) {
        modalWrapEl.style.cursor = cursorStyle.bottomLeft
        // 右上角
      } else if (right < 8 && right >= -5 && top <= 5 && top > -8) {
        modalWrapEl.style.cursor = cursorStyle.topright
        // 右下角
      } else if (right < 8 && right >= -5 && bottom <= 5 && bottom > -8) {
        modalWrapEl.style.cursor = cursorStyle.bottomRight
      } else {
        modalWrapEl.style.cursor = cursorStyle.auto
      }
    }, 20)
  }
  inited = true
}
onMounted(() => {
  initDrag()
})
const close = () => {
  hungUp()
}
//查看关联工单
const getWorkOrder = () => {
  getTcccWorkOrderList({ phone: TcccUserInfo.value.phone }).then((res = []) => {
    const path = router?.currentRoute?.value?.path || ''
    if (path === '/todo') {
      store.commit(
        'workOrder/SEARCH_WORK_ORDER',
        JSON.stringify({ workOrderIdList: res.join('、') })
      )
    } else {
      router.push({
        path: '/todo',
        query: {
          workOrderIdList: res.join('、')
        }
      })
    }
  })
}
// 转投诉
// const transferToComplaint = intent => {
//   const params = {
//     afterIntent: intent,
//     tcccSessionId: TcccUserInfo.value.options.sessionId
//   }
//   buildCallIntent(params)
//   callTransfer(intent)
// }
const { getTransferInfo, data } = useServiceInfo(TcccUserInfo.value)
onMounted(() => {
  getTransferInfo()
})
</script>
<style scoped lang="scss">
.draggable-modal {
  .modal {
    position: fixed;
    top: 64px;
    right: 40px;
    padding: 0;
    width: 180px;
    min-height: 68px;
    background-color: rgba(26, 32, 51, 0.8);
    background-image: url('../../assets/img/chat/tccc.png');
    background-size: 100% 100%;
    border-radius: 8px;
    overflow: hidden;
    z-index: 99999999;
    transition: width 0.2s ease, height 0.2s ease;
    .modal-body {
      padding: 14px;
      .userInfo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          display: flex;
          align-items: center;
          justify-content: space-between;
          img {
            width: 40px;
            height: 40px;
            border-radius: 4px;
          }
          .left-name {
            .name {
              font-weight: 500;
              font-size: 14px;
              color: #ffffff;
              margin-left: 8px;
              line-height: normal;
            }
            .state {
              font-weight: 500;
              font-size: 14px;
              color: #52c41a;
              margin-left: 8px;
            }
          }
        }
        .right {
          font-size: 14px;
          padding: 0;
          margin-left: 8px;
        }
      }
      .status {
        font-weight: 500;
        font-size: 18px;
        color: #52c41a;
        padding: 12px 0 12px 0;
      }
      .history {
        padding: 12px 0;
        .service-inquiry {
          font-size: 14px;
          margin-bottom: 12px;
          color: #fff;
        }
        .last-service {
          font-size: 14px;
          color: #d6d6d6;
        }
      }
      .action {
        width: 100%;
        flex-direction: row-reverse;
        flex-wrap: wrap;
        margin-top: 12px;
        .btn-group {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          gap: 8px;
          white-space: nowrap;
        }
        .btn {
          background: #ffffff;
          border-radius: 4px;
          padding: 2px 16px;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          cursor: pointer;
          letter-spacing: 3px;
        }
        .close {
          font-size: 14px;
          color: #ffffff;
          line-height: 24px;
          background: #f5222d;
        }
      }
    }
  }
  .expanded {
    width: 354px;
    max-height: 240px;
  }
}
</style>
